<nav class="breadcrumb" [attr.nav-collapse]="isNavCollapse">
  <li>
    <button class="primary-500" (click)="back(null)">
      <fa-icon [icon]="faArrowLeft"></fa-icon>
    </button>
    |
    <button class="primary-500" [routerLink]="'/'">
      <fa-icon [icon]="faHouse"></fa-icon>
    </button>
  </li>
  @for (breadcrumb of breadcrumbs(); track i; let i = $index) {
    <li>
      <fa-icon class="gray-300" [icon]="faChevronRight"></fa-icon>
      <button
        class="text--sm text--medium primary-500"
        [ngClass]="breadcrumbs().length === i + 1 ? 'breadcrumb-active' : ''"
        [disabled]="breadcrumbs().length === i + 1"
        (click)="back(breadcrumb.url)"
      >
        {{ breadcrumb.label }}
      </button>
    </li>
  }
</nav>
